export default "__VITE_PUBLIC_ASSET__85ed9d1e__"